module.exports = __webpack_public_path__ + "img/Type_Water.5cba96a7.png";